<template>
    <div>
        <el-radio-group v-model="filterData.age" @change="getAgeWisePatenkinderCounter">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-radio :label="'0-5'">{{ $t('0 to 5 Age') }}</el-radio>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-radio :label="'6-10'">{{ $t('6 to 10 Age') }}</el-radio>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-radio :label="'11-18'">{{ $t('11 to 18 Age') }}</el-radio>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-radio :label="'18'">{{ $t('Above 18') }}</el-radio>
                </el-col>
            </el-row>
        </el-radio-group>
        <el-row>
            <el-col :xs="24">
            <el-card class="case-card p-age-card">
                <div class="case-detail">
                    <h4>{{ patenkinderAgeWise.age }}</h4>                    
                    <p>{{ $t('Patenkinder') }}</p>
                </div>
                <!-- <div class="case-img">
                    <img :src="'/static/case-detail/amount.svg'" alt="hand-image">
                </div> -->
            </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<style lang="scss">
    .p-age-card {
        margin-top: 30px;
    }
    .p-age-card .el-card__body {
        display: block !important; 
        text-align: center;
    }
    .p-age-card .el-card__body h4 {
        font-size: 450% !important;
    }
    .p-age-card .el-card__body p {
        text-transform: none !important;
    }
</style>
<script>
    
    export default {
        components: {
            
        },
        computed: {
            
        },
        data() {
            return {
                filterData:{
                    age: '0-5'
                },
                patenkinderAgeWise: {}
            }
        },
        mounted() {
            this.getAgeWisePatenkinderCounter()
        },
        methods: {
            getAgeWisePatenkinderCounter() {
                request({
                    url: "get-age-wise-patenkinders-count",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.patenkinderAgeWise = response.data.data;
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/Other/AgeWisePatenkinder.vue